const BpMarkerModel = (json, lang) => {
  let data = [];
  
  // Process establishment markers
  if (json && json.establishment_markers && json.establishment_markers.length > 0) {
    for (let i = 0; i < json.establishment_markers.length; i++) {
      let marker = json.establishment_markers[i];
      if (marker) {
        data.push({
          marker: marker.marker,
          datasource: marker.datasource,
          default: true,
          order_weight: marker.score,
        });
      }
    }
  }

  // Process enterprise markers
  if (json && json.enterprise_markers && json.enterprise_markers.length > 0) {
    for (let i = 0; i < json.enterprise_markers.length; i++) {
      let marker = json.enterprise_markers[i];
      if (marker) {
        data.push({
          marker: marker.marker,
          datasource: marker.datasource,
          default: true,
          order_weight: marker.score,
        });
      }
    }
  }

  // Process group markers
  if (json && json.group_markers && json.group_markers.length > 0) {
    for (let i = 0; i < json.group_markers.length; i++) {
      let marker = json.group_markers[i];
      if (marker) {
        data.push({
          marker: marker.marker,
          datasource: marker.datasource,
          default: true,
          order_weight: marker.score,
        });
      }
    }
  }



  return data; // Return only the first marker

};

export default BpMarkerModel;
